/**
 * `/studio/clients` — the book. The page is `pages/studio/clients/`.
 *
 * `?status=` is the mockup's own seg (Active · Past due · Cancelled · All) plus No
 * retainer, and it is `clients_summary`'s own input, so the schema is the shared one
 * the action validates with rather than a second list of the same five words.
 *
 * `routeSearch` is what makes any other word fall back to Active rather than take the
 * page down — the schema is still the declaration, and still the only list.
 */

import { createFileRoute } from '@tanstack/react-router'

import { ClientsPage, ClientsSearchSchema } from '../../../pages/studio/clients/ClientsPage.js'
import { routeSearch } from '../../../search/useSearchState.js'

export const Route = createFileRoute('/studio/clients/')({
  validateSearch: routeSearch(ClientsSearchSchema),
  component: ClientsPage,
})
